import { Alert, Typography, Box } from '@mui/material';

const LocationDeny = () => {
    return (
        <div>
            <Alert severity="error" sx={{ mt: 2, p: 2}}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Please enable location access in your browser:
                </Typography>

                <Box sx={{ mt: 1, lineHeight: 1.6 }}>
                    <Typography variant="body2">
                        <strong>Chrome:</strong> Go to Settings → Privacy and security → Site Settings → Location → Allow for this site.
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                        <strong>Firefox:</strong> Go to Preferences → Privacy & Security → Permissions → Location → Settings → Allow this site.
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                        <strong>Safari (Mac):</strong> Go to Safari → Settings for This Website → Location → Allow.
                    </Typography>
                </Box>
            </Alert>
        </div>
    )
}

export default LocationDeny
